import { BaseModel } from "./base.model";

export class RolMenuOpcionesModel {
    public Id: Number;
    public IdRol: number;
    public IdMenuOpciones: number;
    public IdAplicacion: number;
    public IdMenu: number;

    public Permisos: RolMenuOpcionesPermisosModel[];
}

export class RolMenuOpcionesPermisosModel {
    public Id: Number;
    public IdMenuOpcionRol: number;
    public IdApartado: number;
    public IdPermiso: number;

    public IdMenuOpcion: number;
    public Acronimo: string;
    public Apartado: string;
}

export class PermisoModel extends BaseModel {
    public Id: number;
    public Nombre: string;
    public Descripcion: string;
    public Acronimo: string;
}

